import ApiService from "@/api";
import {
  mapGetTagsRequest,
  mapGetTagsResponse,
} from "@/components/task-forms/components/task-drawer/adapter/AdapterServiceMappers";
import { TagModel } from "@/components/task-forms/models";
import {
  GetTagsListDetailRequest,
  GetTagsListDetailResponse,
} from "@/components/tasks-kanban/components/options-filter/components/filter-parameter/adapter/models";
import {
  WeeekOptionsGetPrioritiesRequest,
  WeeekOptionsGetStatusesRequest,
  WeeekOptionsGetStatusesResponse,
  WeeekOptionsGetTagsRequest,
  WeeekOptionsGetTypesRequest,
} from "@/models";
import { WeeekOptionsGetPrioritiesResponse } from "@/models/WeeekOptionsGetPrioritiesResponse";
import { WeeekOptionsGetTagsResponse } from "@/models/WeeekOptionsGetTagsResponse";
import WeeekOptionsGetTypesResponse from "@/models/WeeekOptionsGetTypesResponse";
import WeeekOptionsGetProjectOptionsRequest from "@/pages/project-settings-weeek-page/models/WeeekOptionsGetProjectOptionsRequest";
import WeeekOptionsGetProjectOptionsResponse from "@/pages/project-settings-weeek-page/models/WeeekOptionsGetProjectOptionsResponse";
import { ResponseModel } from "tir-pm-file-upload-manager";

export class AdapterService {
  private readonly api = new ApiService();

  /**Получить настройки проекта */
  getProjectOptionsAsync(
    request: WeeekOptionsGetProjectOptionsRequest,
  ): Promise<ResponseModel<WeeekOptionsGetProjectOptionsResponse>> {
    return new Promise<ResponseModel<WeeekOptionsGetProjectOptionsResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsGetProjectOptionsResponse>();

      await this.api.Weeek.WeeekOptionsWsController.getProjectOptionsAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }

  /** Получение сопоставления cтатусов weeek */
  async getStatusesWeeek(
    request: WeeekOptionsGetStatusesRequest,
  ): Promise<ResponseModel<WeeekOptionsGetStatusesResponse>> {
    return new Promise<ResponseModel<WeeekOptionsGetStatusesResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsGetStatusesResponse>();

      await this.api.Weeek.WeeekOptionsWsController.getStatusesAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }
  /** Получение сопоставления приоритетов weeek*/
  async getPrioritiesWeeek(
    request: WeeekOptionsGetPrioritiesRequest,
  ): Promise<ResponseModel<WeeekOptionsGetPrioritiesResponse>> {
    return new Promise<ResponseModel<WeeekOptionsGetPrioritiesResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsGetPrioritiesResponse>();

      await this.api.Weeek.WeeekOptionsWsController.getPrioritiesAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }
  /** Получение сопоставления типов weeek*/
  getTypesAsync(
    request: WeeekOptionsGetTypesRequest,
  ): Promise<ResponseModel<WeeekOptionsGetTypesResponse>> {
    return new Promise<ResponseModel<WeeekOptionsGetTypesResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsGetTypesResponse>();

      await this.api.Weeek.WeeekOptionsWsController.getTypesAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }
  /** Получение сопоставления тегов weeek*/
  getTagsAsync(
    request: WeeekOptionsGetTagsRequest,
  ): Promise<ResponseModel<WeeekOptionsGetTagsResponse>> {
    return new Promise<ResponseModel<WeeekOptionsGetTagsResponse>>(async (resolve) => {
      const result = new ResponseModel<WeeekOptionsGetTagsResponse>();

      await this.api.Weeek.WeeekOptionsWsController.getTagsAsync(request)
        .then((response) => {
          result.Value = response;
          resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getProjectOptionsAsync", e);
          return resolve(result);
        });
    });
  }
  /**
   * * Получить список тегов проекта PM
   */
  getTagsProjectPm(request: GetTagsListDetailRequest) {
    return new Promise<ResponseModel<GetTagsListDetailResponse>>(async (resolve) => {
      const result = new ResponseModel<GetTagsListDetailResponse>();

      await this.api.Main.TagGetService.getTagsListDetailAsync(request)
        .then((resp) => {
          result.Value = resp;
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR getTags", e);
          return resolve(result);
        });
    });
  }
}
